import { lazy } from 'react'

export const AboutUs = lazy(() =>
  import('../../views/aboutUs').then((module) => ({ default: module.Team }))
)
export const Project = lazy(() =>
  import('../../views/project').then((module) => ({ default: module.Project }))
)
export const Contact = lazy(() =>
  import('../../views/contact').then((module) => ({ default: module.Contact }))
)
export const Home = lazy(() =>
  import('../../views/home').then((module) => ({ default: module.Home }))
)
export const Places = lazy(() =>
  import('../../views/places').then((module) => ({ default: module.Places }))
)
export const Login = lazy(() =>
  import('../../views/login').then((module) => ({ default: module.Login }))
)

export const Join = lazy(() =>
  import('../../views/join').then((module) => ({ default: module.Join }))
)

export const Verify = lazy(() =>
  import('../../views/verify').then((module) => ({ default: module.Verify }))
)

export const News = lazy(() =>
  import('../../views/news').then((module) => ({ default: module.News }))
)

export const FAQ = lazy(() => import('../../views/faq').then((module) => ({ default: module.FAQ })))

export const PrivacyPolicy = lazy(() =>
  import('../../views/privacyPolicy').then((module) => ({ default: module.PrivacyPolicy }))
)

export const CommunityGuidelines = lazy(() =>
  import('../../views/communityGuidelines').then((module) => ({
    default: module.CommunityGuidelines,
  }))
)

export const ResetPassword = lazy(() =>
  import('../../views/resetPassword/reset').then((module) => ({ default: module.ResetPassword }))
)

export const ResetPasswordConfirmation = lazy(() =>
  import('../../views/resetPassword/confirmation').then((module) => ({
    default: module.ResetPasswordConfirmation,
  }))
)

export const ResetPasswordVerify = lazy(() =>
  import('../../views/resetPassword/verify').then((module) => ({
    default: module.ResetPasswordVerify,
  }))
)

export const CapacitorRedirect = lazy(() =>
  import('../../components/common/CapacitorRedirect').then((module) => ({
    default: module.CapacitorRedirect,
  }))
)
